<template>
  <div>
    <!-- <MPHeader>
      Reporte por robo o <span>extravío</span>.
    </MPHeader> -->
    <!-- <StealLossReportForm /> -->
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Aclaraciones y reclamaciones.</li>
      </template>
      <template slot="title">
        Reporte por robo o extravío.
      </template>
      <template slot="body">
        <StealLossReportForm />
      </template>
    </GenericPage>
  </div>
</template>

<script>
import GenericPage from "./new-portal-views/GenericPage.vue";
import StealLossReportForm from "@components/steal-loss-report/StealLossReportForm";
export default {
name: "StealLossReportPage",
  components: {StealLossReportForm, GenericPage},
}
</script>

<style scoped>

</style>